module.exports = __webpack_public_path__ + "static/img/满意度调查.2f85174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/满意度调查.jpg
// module id = qhsU
// module chunks = 17